<template>
  <div>
    <input
      type="email"
      :class="'form-control ' + input.class"
      :value="value"
      @input="(e) => handleChange(e)"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :name="input.name"
      :id="input.id ? input.id : input.name"
    />
  </div>
</template>
<script>
export default {
  name: "InputEmail",
  components: {},
  props: {
    input: Object,
    value: String,
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
